var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({attrs:{"type":"radio"},domProps:{"checked":_vm.modelValue === _vm.$attrs.value},on:{"change":function($event){return _vm.onChange($event.target.value)}}},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }